import axios from 'axios';
import { applyEnvelopeInterceptor } from '@workpay/ds-shared/services/envelopeInterceptor';

/**
 * Unauthenticated HTTP client for external signing/review flows.
 * No auth headers — all access is token-based.
 *
 * The shared envelope interceptor unwraps the uniform `{ status, data }`
 * response and rejects a normalised WorkpayApiError on failure. No app-level
 * side-effects are wired — external flows are token-scoped and handle
 * auth/expiry per-page (terminal-state screens), not via a global redirect.
 */
export const publicClient = axios.create({
  baseURL: '/api/contract-service',
  headers: { 'Content-Type': 'application/json' },
});

applyEnvelopeInterceptor(publicClient);
